const VIEW_WINDOW_MS = 24 * 60 * 60 * 1000;
const loggedViews = new Map();

function prune(now) {
  loggedViews.forEach((loggedAt, token) => {
    if (now - loggedAt >= VIEW_WINDOW_MS) {
      loggedViews.delete(token);
    }
  });
}

export function _resetLoggedPresentationViewsForTests() {
  loggedViews.clear();
}

export function shouldRecordMeaningfulView(token) {
  if (!token) return false;
  const key = String(token);
  const now = Date.now();
  prune(now);
  if (loggedViews.has(key)) return false;
  loggedViews.set(key, now);
  return true;
}
